module.exports = __webpack_public_path__ + "h5/img/yyzz.0f98a349.jpg";